module.exports = __webpack_public_path__ + "static/media/login.0786ba64.png";